interface StatusCode {
  nom: string;
  valeur: number;
  description: string;
}

const statusCodes: StatusCode[] = [
  {
    nom: "OK",
    valeur: 0,
    description: "Pas d'erreur, le traitement demandé par le LG a été exécuté avec succès",
  },
  {
    nom: "WARNING",
    valeur: 1,
    description:
      "Le traitement demandé par le LG a été exécuté avec succès, mais il est nécessaire d'afficher un message au PS avant de poursuivre le traitement. Le LG doit afficher <libRetour> au PS et poursuivre son traitement (ex : lecture d'une CVIT sans CPS : les éventuelles exonérations du patient ne sont pas présentes dans la réponse d'AF",
  },
  {
    nom: "SESSION_OCCUPEE",
    valeur: 3,
    description:
      "Valeur renvoyée par la fonction 'verifierSession' pour indiquer qu'une opération est en cours d'exécution dans la session.",
  },
  {
    nom: "FATAL",
    valeur: -1,
    description:
      "Erreur Critique de fonctionnement : Appeler la hotline (cas rare : limite mémoire, swap, disque atteinte ou BUG AreaFSE)",
  },
  {
    nom: "ABORT",
    valeur: -2,
    description:
      "L'utilisateur a abandonné l'opération de saisie demandée par AF en cliquant sur annuler ou sur la croix de fermeture de la fenêtre. Le LG devrait considérer qu'il souhaite abandonner l'opération qu'il avait initialement demandé ; en général <facturer>",
  },
  {
    nom: "PARAMETRE_APPEL",
    valeur: -4,
    description: "Erreur sur un des paramètres d'appel : manquant ou incorrect",
  },
  {
    nom: "SESSION_INTROUVABLE",
    valeur: -5,
    description:
      "L’ID de session fournit en entrée est inconnu. Le LG peut automatiquement ré-ouvrir une session sans afficher le <libRetour>.",
  },
  {
    nom: "PS_INCONNU",
    valeur: -6,
    description:
      "l'identifiant de facturation n'a pas été créé dans AF: vérifier l'IDFAC et appeler <creerParamPS>",
  },
  {
    nom: "LECTEUR_INTROUVABLE",
    valeur: -7,
    description:
      "le lecteur n'existe pas dans le fichier 'galss.ini', NB : le galss.ini est interprété au lancement d'AF.",
  },
  {
    nom: "FICHIER_INTROUVABLE",
    valeur: -8,
    description:
      "problème d'accès à un fichier (ex : problème de droits, fichier introuvable)",
  },
  {
    nom: "STRUCTURE_INCORRECTE",
    valeur: -9,
    description:
      "Erreur sur l'objet d'entrée XML donnée manquante ou erreur de type",
  },
  {
    nom: "OPERATION_CONCURRENTE",
    valeur: -10,
    description:
      "La même opération est lancée plusieurs fois de manières concurrentes (ex: mettreEnLot)",
  },
  {
    nom: "VERSION_INCOMPATIBLE",
    valeur: -11,
    description:
      "L'utilisation de lecteur avec une version de l'EI96 antérieure à la version 3.0 est interdite pour les spécialités Fournisseurs",
  },
  {
    nom: "SSV",
    valeur: -1000,
    description:
      "erreur remontée par les API SSV du GIESV : ne doit pas se produire car AF valide les paramètres d'entrée avant l'appel",
  },
  {
    nom: "ZONE_MEMOIRE_SSV",
    valeur: -1001,
    description:
      "réponse incorrecte des API SSV : ne doit pas se produire car pour une version donnée des APISSV, les différents types de réponses ont été validés par AreaSante",
  },
  {
    nom: "STS",
    valeur: -1002,
    description:
      "erreur remontée par les API STS du GIESV : ne doit pas se produire car AF valide les paramètres d'entrée avant l'appel",
  },
  {
    nom: "ZONE_MEMOIRE_STS",
    valeur: -1003,
    description:
      "réponse incorrecte des API STS : ne doit pas se produire car pour une version donnée des API STS, les différents types de réponses ont été validés par AreaSante",
  },
  {
    nom: "SRT",
    valeur: -1004,
    description:
      "erreur remontée par les API SRT du GIESV : ne doit pas se produire car AF valide les paramètres d'entrée avant l'appel",
  },
  {
    nom: "ZONE_MEMOIRE_SRT",
    valeur: -1005,
    description:
      "réponse incorrecte des API SRT : ne doit pas se produire car pour une version donnée des API SRT, les différents types de réponses ont été validés par AreaSante",
  },
  {
    nom: "ADR",
    valeur: -1100,
    description:
      "erreur liée au service ADRi (erreur renvoyé par le service, données retours non conformes, …)",
  },
  {
    nom: "CESI",
    valeur: -1200,
    description:
      "Pas utilisée pour le moment. Prévu pour les erreurs liées aux rapports de réclamation CESI",
  },
  {
    nom: "ANNUAIRE_AMC",
    valeur: -1300,
    description:
      "erreur liée à l'annuaire AMC (erreur renvoyé par le service, données retours non conformes, …)",
  },
  {
    nom: "APCV",
    valeur: -1400,
    description:
      "erreur liée au service ApCV(erreur renvoyé par le service, données retours non conformes, …)",
  },
  {
    nom: "RENOUVELER_CTXT_APCV",
    valeur: -1401,
    description:
      "erreur indiquant qu'il convient de renouveler le contexte ApCV (contexe expiré/invalide, nombre max de facture atteint, …). En retour de 'facturer', le LG doit proposer automatiquement de redemander un contexte d'authentification ApCV et rappeler ensuite la fonction 'facturer'. Dans ce cas, il faut quand même affiché <libRetour>.",
  },
  {
    nom: "MAJ_TABLE",
    valeur: -2000,
    description:
      "erreur dans fonction de maj referentiel ex fichier CONV introuvable, supprimer une convention inexistante, ….",
  },
  {
    nom: "SECURISATION",
    valeur: -2001,
    description:
      "FSE ou DRE non sécurisable (ex : déjà sécurisée)",
  },
  {
    nom: "ELEMENT_INTROUVABLE",
    valeur: -2002,
    description:
      "demande de traitement d'un élément inexistant plutôt sur données de travail (pas referentiel) ex sécuriser une FSE qui n'existe pas ou qui n'est pas désynchronisé",
  },
  {
    nom: "TRAITEMENT_ANOMALIE",
    valeur: -2003,
    description:
      "traiterlotabsARL ou ARL- sur un lot pas dans le bon etat",
  },
  {
    nom: "IMPORT_CSV",
    valeur: -2004,
    description:
      "import d'un fichier CSV impossible (ex: problème de format), lors de la mise à jour du référentiel (organismes destinataires, conventions, …)",
  },
  {
    nom: "SUPPRESSION",
    valeur: -2005,
    description:
      "erreur lors de la suppression d'un élément dans les données de travail (pas référentiel) (ex: tentative de suppression d'une facture, après sa mise en lot)",
  },
  {
    nom: "DRE_ANNULATION",
    valeur: -2006,
    description:
      "la génération d'une DRE d'annulation n'est pas possible (ex: refus au niveau de la convention, pas de DRE initiale trouvée, …). Certains cas peuvent être empêchés au niveau du LG (absence de DRE initiale, DRE d'annulation déjà émise, DRE initiale pas encore télétransmise)",
  },
  {
    nom: "DOUBLON_FACTURE",
    valeur: -2007,
    description:
      "le numéro de facture existe déjà dans les données de travail",
  },
  {
    nom: "ERREUR_TEMPORAIRE",
    valeur: -2008,
    description:
      "L'opération ne peut être exécutée à cet instant, mais devrait fonctionner si on la relance ultérieurement (ex : pose de verrou impossible, 2 utilisateurs utilisant le même idfac lancent simultanément une mise en lot). Risque d'occurrence très faible, l'utilisateur doit relancer l'opération",
  },
  {
    nom: "INCOHERENCE_CARTES",
    valeur: -4000,
    description:
      "distorsion entre l'opération demandée (facturer, mettreEnLot) et les cartes présentes dans les lecteurs (CPx, Carte Vitale",
  },
  {
    nom: "PRESTATION_INCONNUE",
    valeur: -4001,
    description:
      "AF a indiqué au PS que le code prestation n'est pas connu dans le référentiel, et ce dernier n'a pas voulu forcer l'utilisation du nouveau code",
  },
  {
    nom: "INCOMPATIBILITE_ATTRIBUT",
    valeur: -4002,
    description:
      "la règlementation relative au code prestation n'est pas respectée (ex: prestation non compatible avec l'âge du bénéficiaire). Dans certains cas, AF peut d'abord proposer un forçage à l'utilisateur",
  },
  {
    nom: "CONTEXTE_TP",
    valeur: -4003,
    description:
      "le contexte Tiers-Payant n'est pas conforme à la règlementation (ex: facture Hors Tiers-Payant en nature d'assurance AT ; impossible, le TP est obligatoire en AT)",
  },
  {
    nom: "FSE_MATERNITE",
    valeur: -4004,
    description:
      "non respect d'une règle de facturation spécifique à la nature d'assurance Maternité",
  },
  {
    nom: "FSE_AT",
    valeur: -4005,
    description:
      "non respect d'une règle de facturation spécifique à la nature d'assurance AT",
  },
  {
    nom: "FSE_ACCIDENT",
    valeur: -4006,
    description:
      "non respect d'une règle de facturation spécifique aux Accidents de Droits Communs (accidents de la vie privée)",
  },
  {
    nom: "FSE_NON_ATTENDUE",
    valeur: -4007,
    description:
      "la règlementation ne prévoit pas l'envoi d'une FSE (ex : l'envoi d'une FSE sécurisée pour la CAVIMAC avec un code situation compris entre 9020 et 9024 est interdit ; règle [R18])",
  },
  {
    nom: "FACTURATION_AMO",
    valeur: -4008,
    description:
      "la facturation de la part obligatoire n'est pas possible (ex : droits fermés, organisme introuvable, …)",
  },
  {
    nom: "MODE_SECURISATION",
    valeur: -4009,
    description:
      "problème avec le mode de sécurisation (ex: mode SESAM Sans Vitale pas impossible pour les fournisseurs, sauf location ou service)",
  },
  {
    nom: "CLE_INVALIDE",
    valeur: -4010,
    description:
      "une vérification de clé Luhn a échoué (ex: n° prescripteur, n°AT, NIR)",
  },
  {
    nom: "TAILLE_FACTURE",
    valeur: -4011,
    description:
      "la facture contient trop d'éléments pour être traitée par les fournitures SV : répartir les actes sur plusieurs factures",
  },
  {
    nom: "FACTURATION_AMC",
    valeur: -5000,
    description:
      "la facturation de la part complémentaire n'est pas possible (ex : droits fermés, absence de conventions, …)",
  },
  {
    nom: "TARIFICATION_AMC",
    valeur: -5001,
    description:
      "problème lors de la tarification AMC STS (ex: la tarification nécessite l'appel à l'assistance STS et le PS refuse)",
  },
  {
    nom: "ASSISTANCE_STS",
    valeur: -5002,
    description:
      "l'appel à l'assistance STS n'est pas possible (ex : facture hors TP AMC, STS désactivée pour la convention sélectionnée)",
  },
  {
    nom: "SIGNATURE_DEMANDE_DLOI",
    valeur: -6000,
    description:
      "ne concerne pas les fournisseurs",
  },
  {
    nom: "LOI_CORROMPUE",
    valeur: -6001,
    description:
      "ne concerne pas les fournisseurs",
  },
  {
    nom: "LOI_ACTIVE_INTROUVABLE",
    valeur: -6002,
    description:
      "ne concerne pas les fournisseurs",
  },
  {
    nom: "APPLICATION_DLOI",
    valeur: -6003,
    description:
      "ne concerne pas les fournisseurs",
  },
  {
    nom: "HABILITATION_LOI",
    valeur: -6004,
    description:
      "ne concerne pas les fournisseurs",
  },
  {
    nom: "LOI_DESACTIVE",
    valeur: -6005,
    description:
      "ne concerne pas les fournisseurs",
  },
  {
    nom: "LOI_ANCIENNE",
    valeur: -6006,
    description:
      "ne concerne pas les fournisseurs",
  },
  {
    nom: "IMPORT_CERTIFICAT_AC",
    valeur: -7000,
    description:
      "pas utilisé pour le moment",
  },
  {
    nom: "RECEPTION_MESSAGES",
    valeur: -8000,
    description:
      "problème de réception des messages (ex: connexion au serveur POP3 impossible)",
  },
  {
    nom: "EMISSION_MESSAGES",
    valeur: -8001,
    description:
      "problème d'envoi d'un message (ex: connexion au serveur SMTP impossible)",
  },
  {
    nom: "COMMUNICATION_AREA",
    valeur: -8002,
    description:
      "problème de communication avec les services Area Santé (ex: connexion au serveur impossible)",
  },
  {
    nom: "ERREUR_IMPREVUE",
    valeur: -9999,
    description:
      "Erreur Critique de fonctionnement de la machine virtuelle java : Appeler la hotline (cas rare : limite mémoire, swap, disque atteinte ou BUG AreaFSE)",
  },
];

function getStatusCodeByValue(value: number): StatusCode | undefined {
  return statusCodes.find(statusCode => statusCode.valeur === value);
}

export { StatusCode, statusCodes, getStatusCodeByValue };